/**
 * Parallax.js Lazy Loader
 *
 * Only loads parallax.js if the page contains elements with data-parallax="scroll"
 * This avoids loading ~8KB of parallax code on pages that don't use it
 */

(function() {
    // Check if any parallax elements exist on the current page
    const hasParallaxElements = document.querySelector('[data-parallax="scroll"]') !== null;

    if (hasParallaxElements) {
        // Dynamically import parallax only if needed
        // This will be bundled separately but only loaded when parallax elements exist
        import('./parallax.js');
    }
})();
